import { INTERNAL_ROUTING, ROUTES } from 'shared/constants';
import { navigate as navigateService } from 'shared/services/navigation.service';

// Define viewer params that should be mutually exclusive
export const VIEWER_PARAMS = [
  INTERNAL_ROUTING.QUERY_PARAMS.KNOWLEDGE,
  INTERNAL_ROUTING.QUERY_PARAMS.COMPENDIUM,
  INTERNAL_ROUTING.QUERY_PARAMS.CHECKLIST,
];

/**
 * Helper function to update query params with mutually exclusive viewer params handling
 * @param {URLSearchParams} searchParams - URLSearchParams object to modify
 * @param {string} key - The param key to set
 * @param {string|null} value - The value to set (null to delete)
 * @returns {URLSearchParams} Modified searchParams
 */
export const updateQueryParamWithExclusivity = (searchParams, key, value) => {
  if (value) {
    // Remove other viewer params - only one viewer open at a time
    if (VIEWER_PARAMS.includes(key)) {
      VIEWER_PARAMS.forEach(param => {
        if (param !== key) {
          searchParams.delete(param);
        }
      });
    }
    searchParams.set(key, value);
  } else {
    searchParams.delete(key);
  }
  return searchParams;
};

export const routeWithQueryParam = ({ key, value = null }) => {
  const basename = process.env.REACT_APP_ROUTER_BASENAME || '';
  let path = window.location.pathname;
  if (basename && path.startsWith(basename)) {
    path = path.slice(basename.length) || '/';
  }
  const searchParams = new URLSearchParams(window.location.search);

  updateQueryParamWithExclusivity(searchParams, key, value);

  const queryString = searchParams.toString();
  navigateService(queryString ? `${path}?${queryString}` : path);
};

export const getQueryParam = ({ key }) => new URLSearchParams(window.location.search).get(key);

export const redirectToRestrictedAccessPage = ({ entity, id }) => {
  const searchParams = new URLSearchParams();
  searchParams.set(INTERNAL_ROUTING.QUERY_PARAMS.RESTRICTED_ENTITY, entity);
  searchParams.set(INTERNAL_ROUTING.QUERY_PARAMS.RESTRICTED_ID, id);
  navigateService(`${ROUTES.RESTRICTED}?${searchParams.toString()}`);
};
